/**
 * Backend API base URL (no trailing slash).
 * - Local: `.env.development` → http://localhost:8080/api
 * - Production build: `.env.production` → https://api.nidra.io/api
 * - Docker prod/dev Dockerfiles also pass REACT_APP_API_BASE at build time.
 */
const DEFAULT_DEV = "http://localhost:8080/api";
const DEFAULT_PROD = "https://api.nidra.io/api";

export const getApiBase = () => {
  const fromEnv = process.env.REACT_APP_API_BASE;
  if (fromEnv) {
    return fromEnv.replace(/\/$/, "");
  }
  return process.env.NODE_ENV === "development" ? DEFAULT_DEV : DEFAULT_PROD;
};
